// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"224":"489a27dd90303174","519":"0114304c9034dddc"}[chunkId] + ".css";
};